@if (value === -1) {
  <div class="none-container">
    <!-- <span>keine Testung</span> -->
  </div>
} @else {
  <div class="progress-container" [style.border-color]="getColor()">
    <div class="progress-bar" [style.width]="value + '%'" [style.background-color]="getColor()"></div>
    <span class="text">{{ value }} %</span>
  </div>
}
